import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-97d2c33e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "call-to-action" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { innerHTML: '/{{ 1 }}' }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_select = _resolveComponent("md-select")!
  const _component_md_input_field = _resolveComponent("md-input-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_md_select, {
      error: false,
      style: {"width":"23%"},
      variant: "outlined",
      size: "small",
      icon: "expand_more",
      modelValue: _ctx.actionType,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.actionType) = $event)),
      label: "Art der Handlung",
      items: _ctx.actionTypes,
      ref: "actionTypeInput",
      onChange: _ctx.updateModelValue
    }, null, 8, ["modelValue", "items", "onChange"]),
    _createVNode(_component_md_input_field, {
      error: false,
      style: {"width":"23%"},
      required: "",
      size: "small",
      variant: "outlined",
      modelValue: _ctx.text,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.text) = $event)),
      label: "Button-Text",
      ref: "textInput",
      "max-characters": 25,
      onChange: _ctx.updateModelValue
    }, null, 8, ["modelValue", "onChange"]),
    _createVNode(_component_md_select, {
      error: false,
      style: {"width":"23%"},
      variant: "outlined",
      size: "small",
      icon: "expand_more",
      modelValue: _ctx.urlType,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.urlType) = $event)),
      label: "URL Type",
      items: _ctx.urlTypes,
      ref: "urlInputType",
      onChange: _ctx.updateModelValue
    }, null, 8, ["modelValue", "items", "onChange"]),
    _createVNode(_component_md_input_field, {
      error: false,
      style: {"width":"23%"},
      required: "",
      size: "small",
      variant: "outlined",
      modelValue: _ctx.url,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.url) = $event)),
      label: "Website-URL",
      ref: "urlInput",
      "max-characters": 2000,
      onChange: _ctx.updateModelValue
    }, null, 8, ["modelValue", "onChange"]),
    _hoisted_2
  ]))
}